<template>
  <div>
    <TopHeader></TopHeader>
    <div class="main_box">
      <div class="title">手机号查单</div>
      <div class="form">
        <el-form ref="form" label-width="160px">
          <el-form-item label="联系人手机号">
            <el-input v-model="mobile" placeholder="请输入手机号码" style="width:340px;"></el-input>
          </el-form-item>
          <el-form-item label="手机验证码">
            <el-input v-model="verificationCode" placeholder="请输入手机验证码" style="width:210px;margin-right:10px;"></el-input>
            <el-button type="primary" plain style="width:120px;" @click="getVerificationCode" :disabled="!verificationBtn">
              <template v-if="verificationBtn">发送验证码</template>
              <template v-if="!verificationBtn">重新获取({{verificationTime}})</template>
            </el-button>
          </el-form-item>
          <el-form-item>
            <div class="searchBtn" @click="query">查 询</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <CopyRight></CopyRight>
  </div>
</template>

<script>
import TopHeader from '../components/TopHeader'
import CopyRight from '../components/CopyRight'
import { validaCellPhone } from '../utils/validate'
import { sendCode, checkCode } from '@/api/buyTicket'
import { clearInterval, setInterval } from 'timers'

export default {
  components: {
    TopHeader,
    CopyRight
  },
  data () {
    return {
      verificationCode: '',
      verificationBtn: true,
      verificationTime: 60,
      mobile: '',
      timer: null
    }
  },
  methods: {
    getVerificationCode () {
      if (!validaCellPhone(this.mobile)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
      } else {
        const data = {
          templateId: 'SMS_T_NORMALCODE',
          mobilePhone: this.mobile
        }
        sendCode(data).then(res => {
          if (res.code === 0) {
            this.verificationBtn = false
            this.verificationTime = 60
            if (this.timer) {
              clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
              if (--this.verificationTime === 0) {
                this.verificationBtn = true
                clearInterval(this.timer)
              }
            }, 1000)
          }
        })
      }
    },
    query () {
      const data = {
        code: this.verificationCode,
        mobilePhone: this.mobile,
        templateId: 'SMS_T_NORMALCODE'
      }
      checkCode(data).then(res => {
        if (res.code === 0) {
          this.$router.push({
            path: '/myOrder',
            query: {
              mobile: this.mobile
            }
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 18px;
  line-height: 65px;
  padding-left: 65px;
  font-weight: bold;
}
.form {
  height: 300px;
  margin-bottom: 200px;
  padding-top: 50px;
  border: 1px solid #ddd;
  box-sizing: border-box;
}
.searchBtn {
  width: 210px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  background-color: #ffb000;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.searchBtn:hover {
  background-color: #faab00;
}
.el-icon-success {
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
  color: goldenrod;
}

.el-icon-error {
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
  color: red;
}
</style>
